import React from "react";
import Navbar from "../components/Navbar";
import BottomNav from "../components/BottomNav";
import "../styles/home.css";

const Returns = () => {
  return (
    <div className="legal-container">
      <Navbar />

      <div className="legal-content">
        <h1>Return Policy</h1>

        <p>Last Updated: March 2026</p>

        <h2>Return Eligibility</h2>
        <p>
          Products can be returned within 2 days of delivery if they are unused
          and in their original packaging.
        </p>

        <h2>Damaged Items</h2>
        <p>
          If you receive a damaged or defective product, please contact our
          support team immediately.
        </p>

        <h2>Refund Process</h2>
        <p>
          Once the returned product is inspected, refunds will be processed
          within 5–7 business days.
        </p>

        <h2>Non-Returnable Items</h2>
          <p>
          Items that are used, damaged by the customer, or returned without
          original packaging may not be eligible for return.
          </p>

          <h2>How to Request a Return</h2>
          <p>
          To initiate a return, please contact our support team with your
          order number and reason for return.
          </p>

          <h2>Refund Method</h2>
            <p>
            Refunds will be credited to the original payment method used
            during the purchase.
            </p>

          <h2>Return Shipping</h2>
          <p>
          Customers may be responsible for return shipping costs unless the
          product was damaged or incorrect.
          </p>


      </div>

      <BottomNav />
    </div>
  );
};

export default Returns;